import React from 'react';
import PropTypes from 'prop-types';
import getProfile from '~/public/assets/javascripts/profile';
import { setLinkCetDataVars } from '~/server/utils/cetTrackingHelper';
import appendQueryParams from '~/server/models/helpers/appendQueryParams';

class MemberStatus extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ready: false,
      profile: undefined,
      signInUrl: props.signInUrl,
      hasMembership: false,
    };
    this.isMobile = props.isMobile;
    this.getText = this.getText.bind(this);
  }

  componentDidMount() {
    getProfile().then((profile) => {
      this.setState({ profile });
      if (profile && profile.membership) {
        this.setState({ hasMembership: profile.membership.hasMembership });
      }
      this.setState({ ready: true });
    }).catch(() => {
      console.error('Error fetching profile');
      this.setState({ ready: true });
    });
    if (this.props.type === 'static_template') {
      this.setState({ signInUrl: this.setStaticSignInUrl() });
    }
  }

  getText() {
    const { navCampaignData } = this.props;
    const { hasMembership } = this.state;

    if (navCampaignData) {
      if (hasMembership) {
        return this.isMobile
          ? navCampaignData.subscribed?.nav_text || 'Thank You!'
          : navCampaignData.subscribed?.nav_text_long || 'Thank You For Supporting Free Journalism';
      }
      return this.isMobile
        ? ''
        : navCampaignData.nav_text || 'Twenty Years of Fearless Reporting';
    }

    // Fallback to hardcoded values
    if (hasMembership) {
      return this.isMobile ? 'Thank You!' : 'Thank You For Supporting Free Journalism';
    }
    if (this.isMobile) {
      return '';
    }
    return 'Twenty Years of Fearless Reporting';
  }

  setStaticSignInUrl = () => {
    const { signInUrl, signInTrackingParams } = this.props;
    const { src, ncid } = signInTrackingParams;
    const dest = window.location.href;
    return appendQueryParams(signInUrl, { dest, src, ncid });
  };

  render() {
    const {
      signInUrl,
      profileUrl,
      subscribeUrl,
      supportHuffpostUrl,
      hideSupportUsButton,
      navCampaignData,
    } = this.props;

    const { hasMembership } = this.state;

    // Use navCampaignData for button/link text and url if present
    let supportButtonText;
    if (navCampaignData) {
      if (this.isMobile) {
        supportButtonText = navCampaignData.link_text || 'Support Us';
      } else {
        supportButtonText = navCampaignData.long_link_text || 'Support The Free Press';
      }
    } else {
      supportButtonText = this.isMobile ? 'Support Us' : 'Support The Free Press';
    }

    const supportButtonUrl = navCampaignData
      ? navCampaignData.link_url || '/support'
      : '/support';

    const joinCetData = setLinkCetDataVars('nav_bar', subscribeUrl, 'Join HuffPost', 'text', 'site_header');
    const logInCetData = setLinkCetDataVars('nav_bar', signInUrl, 'Log In', 'text', 'site_header');
    const supportHuffpostCetData = setLinkCetDataVars('nav_bar', supportHuffpostUrl, 'Support The Free Press', 'text', 'site_header');
    const subscriptionPromo = !supportHuffpostUrl && (
      <a
        className="nav__right__profile__subscription-button"
        href={subscribeUrl}
        {...joinCetData}
      >
        Join HuffPost
      </a>
    );

    const avatar = this.state.profile && this.state.profile.profileImages['128x128'];

    const showSupportButton = !hideSupportUsButton && !hasMembership;

    /* eslint-disable jsx-a11y/interactive-supports-focus */
    /* eslint-disable jsx-a11y/no-static-element-interactions */
    /* eslint-disable jsx-a11y/click-events-have-key-events */
    return this.state.ready
      ? (
        <div className="nav__right__profile__container">
          <span className="nav__support-dek">{this.getText()}</span>
          {showSupportButton
          && (
          <a
            className="nav__right__support-button support-button"
            href={supportButtonUrl}
            {...supportHuffpostCetData}
          >
            <span className="support-button__text">{supportButtonText}</span>
          </a>
          )}
          <div className="nav__right__profile">
            { this.state.profile ? (
              <a
                aria-label="Profile"
                href={profileUrl}
              >
                <img alt="" className="nav__right__profile__image" src={avatar} />
              </a>
            ) : (
              <>
                {subscriptionPromo}
                <a
                  className="nav__right__sign-in"
                  rel="nofollow"
                  href={this.state.signInUrl}
                  {...logInCetData}
                >
                  Log In
                </a>
              </>
            )}
          </div>
        </div>
      )
      : null;
    /* eslint-enable jsx-a11y/interactive-supports-focus */
    /* eslint-enable jsx-a11y/no-static-element-interactions */
    /* eslint-enable jsx-a11y/click-events-have-key-events */
  }
}

MemberStatus.propTypes = {
  type: PropTypes.string,
  signInUrl: PropTypes.string.isRequired,
  profileUrl: PropTypes.string.isRequired,
  subscribeUrl: PropTypes.string.isRequired,
  supportHuffpostUrl: PropTypes.string,
  hideSupportUsButton: PropTypes.bool,
  isMobile: PropTypes.bool,
  navCampaignData: PropTypes.shape({
    link_text: PropTypes.string,
    link_url: PropTypes.string,
    long_link_text: PropTypes.string,
    nav_text: PropTypes.string,
    nav_text_long: PropTypes.string,
    subscribed: PropTypes.shape({
      nav_text: PropTypes.string,
      nav_text_long: PropTypes.string,
    }),
  }),
};

MemberStatus.defaultProps = {
  type: null,
  supportHuffpostUrl: null,
  hideSupportUsButton: true,
  isMobile: false,
  navCampaignData: undefined,
};

export default MemberStatus;
